import React from 'react';
import { StyledLoginMethods } from '../styles/LoginStyles';
import LoginMethod from './LoginMethod';
var LoginMethods = function (_a) {
    var setSelectedLoginMethod = _a.setSelectedLoginMethod, selectedLoginMethod = _a.selectedLoginMethod, loginMethods = _a.loginMethods, testId = _a.testId;
    return (React.createElement(StyledLoginMethods, { "data-testid": "".concat(testId, "-loginMethods") }, loginMethods.map(function (loginMethod, index) {
        return (React.createElement(LoginMethod, { onClick: function () {
                setSelectedLoginMethod(index);
            }, isActive: selectedLoginMethod === index, title: loginMethod, key: loginMethod, id: index, setSelectedLoginMethod: setSelectedLoginMethod, testId: testId }));
    })));
};
export default LoginMethods;
//# sourceMappingURL=LoginMethods.js.map